import { useSelector } from 'react-redux'

import { timezoneSelector } from 'modules/embed/selectors'

const useTimezone = () => useSelector(timezoneSelector)

export default useTimezone
